import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAppUtils from '../../utils/appUtils';
import { useSelector } from 'react-redux';
import { userSelector } from '../../store/slices/user';
import { applicationDataSelector } from '../../store/slices/application-data';
import { fuelUserAccessSliceSelector } from '../../store/slices/fuelUserAccess';
import { Button } from '@mui/material';

const OopsPage = () => {
  const navigate = useNavigate();
  return (
    <div className="oops-page">
      <div className="container">
        <div className="content">
          <h1>Oops!</h1>
          <h2>Something went wrong!</h2>
          <p>
            We are really sorry but the page you requested cannot be reached from here!. But you can click the button below to go
            back to the homepage.
          </p>
          <Button autoFocus color="success" variant="contained" className="btn" onClick={() => navigate('/assets/list')}>
            HOME
          </Button>
        </div>
        {/* <div className='icons'>
      <i className="fa fa-frown-o" aria-hidden="true"></i>
      </div> */}
        <div className="face">
          <div className="band">
            <div className="red"></div>
            <div className="white"></div>
            <div className="blue"></div>
          </div>
          <div className="eyes"></div>
          <div className="dimples"></div>
          <div className="mouth"></div>
        </div>
      </div>
    </div>
  );
};

export default OopsPage;
